module.exports = __webpack_public_path__ + "img/iconCC-Social7.7eb9cee4.png";